import { ICdRead, ICdReadPayload } from "../types/easy-e-m-i-loan-journey-types.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

export const cdRead = async (payload: ICdReadPayload): Promise<IResponse<ICdRead>> => {
  const response = await encryptedRequest<ICdRead, ICdReadPayload>({
    method: "POST",
    url: `${API_PATHS.cdRead}`,
    data: payload,
  });
  return response;
};
